import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Mint from 'bh-mint-ui2';
import {
  Toast
} from 'bh-mint-ui2';
import route from './router';
import * as utils from './utils'
import api from './api'
import axios from 'axios'
import 'bh-mint-ui2/lib/style.css'
import init from 'bh-mixin-sdk'
import {
  Pagination,
  Loading
} from 'element-ui';
import 'babel-polyfill';
// import './rem.js'

if (window.smile) {
  window.Vue = Vue
  window.axios = axios
  if (WEBPACK_CONFIG_HOST) {
    window.WEBPACK_CONFIG_HOST = WEBPACK_CONFIG_HOST
  }
  // 初始化eventBus
  window.smile.eventBus = new Vue()
}

Vue.use(Mint);
Vue.use(VueRouter);
Vue.use(Pagination);
Vue.use(Loading);

const router = new VueRouter(route);

router.beforeEach((to, from, next) => {
  // 加载页面smile依赖
  if (window.smile) {
    var require = []
    var promiseArr = []
    // 拉取require配置中的表单
    if (to.meta.require && to.meta.require.length > 0) {
      require = require.concat(to.meta.require)
    }
    // 拉取传参中的表单
    if (to.query.smileForm) {
      require.push(to.query.smileForm)
    }
    require.map(function (item) {
      if (!window.smile.components[item]) {
        promiseArr.push(window.smile.loadPage(item))
      }
    })
    if (promiseArr.length > 0) {
      Promise.all(promiseArr).then(function () {
        next()
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

global.SDK = null;

function getSDKConfig() {
  return new Promise((resolve, reject) => {
    let config = {
      // 微信sdk初始化参数
      // wx: {
      //   /** 
      //    *微信端上传图片的流程是：
      //    * 1. 选取文件通过微信jssdk上传到微信服务器后获取文件的serverId
      //    * 2. 将serverId发送到应用服务端，服务端接收请求后根据serverId，将文件从微信服务拉取到应用服务
      //    * uploadImgsToEmapUrl 参数 就是步骤2中将serverId发送到应用服务的请求接口
      //    */
      //   corp: 'bkzs',
      //   // uploadImgsToEmapUrl: WEBPACK_CONFIG_HOST + '/sys/yxapp/WechatServiceStu/saveFileFromWechat.do'  //上传接口 
      //   uploadImgsToEmapUrl: WEBPACK_CONFIG_HOST + '/sys/swpubapp/MobileCommon/saveFileFromWechat.do'
      // },
      dd: {}, //钉钉jdk初始化参数
    }
    if (/micromessenger/.test(navigator.userAgent.toLowerCase()) && config.wx) {
    // if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
      /**
       * 判断运行环境为微信时，向后端发送请求获取微信jsdk的授权签名，（此接口应该有后端来提供），请求返回应包含以下参数
       * corpId - 企业号的corpid
       * nonceStr - 生成签名的随机串
       * timestamp - 生成签名的时间戳
       * signature - 签名
       */
      // TODO: 发请求获取微信签名
      config.wx.url = "https://seicwxbz.seu.edu.cn/api/jssdk?extraUrl=http://bkzs.seu.edu.cn/bkzs/sys/yxsyglxsdappseu/index.html";
      // utils.Get(api.getWechatSign, { url: window.location.href.replace(/#(\S+)?/, ''), corp: 'amptest' }).then(({
      utils.Get(config.wx.url).then(({
        data: resp
      }) => {
        // console.log(resp);
        if (resp.success) {
          let signData = resp.result;
          signData.corpId = resp.result.appId;
          // signData.signature=resp.result.signature;
          // signData.nonceStr = signData.nonceStr
          config.wx.signData = signData
          // console.log(signData)
          resolve(config)
          // console.log(config.wx);
        } else {
          Toast('微信jsdk初始化失败 ' + resp.success);
          reject(resp)
        }
      }, () => {
        Toast('微信jsdk初始化失败');
        reject()
      })
    } else {
      setTimeout(function () {
        resolve(config)
      }, 0)
    }
    return config
  })
}

getSDKConfig().then((config) => {
  init((res) => {
    if (res.type === 'success') {
      global.SDK = res.sdk;
      console.log(global.SDK,'99');
      new Vue({
        el: '#app',
        router,
        template: '<App/>',
        components: {
          App
        },
        mounted() {
          if (this._isMobile()) {
            // 初始化
            this.setMobileSize()
            // 改变窗口大小时重新设置rem
            window.addEventListener('resize', () => {
              this.setMobileSize()
            })
          } else {
            let ratio = 0
            let fontSize = 16

            if (window.devicePixelRatio === undefined) {
              ratio = 1
            } else if (window.screen.width * window.devicePixelRatio > 2000) {
              ratio = window.devicePixelRatio / 2
            } else {
              ratio = window.devicePixelRatio
            }

            fontSize = fontSize / ratio

            this.setFontSize(fontSize)
            window.addEventListener('resize', () => {
              this.setFontSize(fontSize)
            })
          }

        },
        methods: {
          setFontSize(fontSize) {
            var custom_adapterZoom = {
              "1280": "0.7",
              "1600": "0.8"
            };
            const clientWidth = document.documentElement.clientWidth
            let scale = 1
            for (let key in custom_adapterZoom) {
              if (clientWidth <= key) {
                scale = custom_adapterZoom[key]
                break
              }
            }
            document.querySelector('html').style.fontSize = fontSize * scale + 'px'
          },
          _isMobile() {
            let flag = navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            return flag;
          },
          setMobileSize() {
            // 基准大小
            const baseSize = 32
            // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
            const scale = document.documentElement.clientWidth / 750
            // 设置页面根节点字体大小
            document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
          }
        }

      });
    }
  }, config)
})


// WEBPACK FOOTER //
// ./src/main.js